(function ($, Cobalt, undefined) {
    Cobalt.Auth = {
        modalLoadTime: 500,
        dependentScripts: function () { return [{ dependency: Cobalt.User, name: "Cobalt.User" }]; },
        initialize: function () {
            // disabling login modal until we can go full ssl
            //Cobalt.Auth.bindLoginLink();

            // temporarily removing register modal link 
            //Cobalt.Auth.bindRegisterLink();
        },
        bindLoginLink: function () {
            $('body').delegate("#login-link,.j-login-link", "click", function (e) {
                e.preventDefault();

                Cobalt.Auth.showLoginModal(window.location.pathname);
            });
        },
            
        bindRegisterLink: function () {
            $('body').delegate("#register-link,.j-register-link", "click", function (e) {
                e.preventDefault();
                if (Cobalt.detectIsOnMobile()) {
                    window.location = "/register?returnUrl=" + window.location.pathname;
                } else {
                    Cobalt.Auth.showRegisterModal(window.location.pathname);
                }
            });
        },

        showLoginModal: function (returnUrl) {
            if (Cobalt.detectIsOnMobile()) {
                window.location = "https://" + window.location.hostname + "/login?returnUrl=" + window.location.pathname;
            } else {
                var $container = $("<section class=\"p-login p-login-b group j-login-modal\"></section>");
                $('body').append($container);
                $container.dialog(
                {
                    autoOpen: false,
                    width: 449,
                    modal: true,
                    title: 'Login to Curse',
                    dialogClass: 'loginModal',
                    close: function () {
                        $container.remove();
                    }
                });

                $container.dialog('open');
                    $container.parent().center();
                $container.append("<div class=\"loadmask\"></div>");

                $.get("https://" + window.location.hostname + "/login-modal", { returnUrl: returnUrl}, function (data) {
                    if (!data.length) {
                        $container.find("div.loadmask").remove();
                        $container.remove();
                        return;
                    }

                    var $html = $(data);
                    // append the data, remove the loading element, then trigger the insert.
                    $container.append($html);
                    $container.find("div.loadmask").remove();
                    Cobalt.triggerHtmlInsert($container);
                    $container.parent().center();

                    // bind register button
                    $container.find("a.j-register-modal").on("click", function (e) {
                        Cobalt.Auth.replaceWithRegisterModel($container);
                    });
                    // focus on username field
                    $('#field-username').focus();
                });

            }            
        },
        showRegisterModal: function (returnUrl) {
            var $container = $("<section class=\"p-register p-register-b group j-register-modal\"></section>");

            $container.dialog(
            {
                autoOpen: false,
                width: 449,
                modal: true,
                title: 'Register with Curse',
                dialogClass: 'register-modal',
                close: function () {
                    $container.remove();
                }
            });

            $container.dialog('open');
            $container.append("<div class=\"loadmask\"></div>");

            // only do ajax request if needed
            $.get("https://" + window.location.hostname + "/register-modal", { returnUrl: returnUrl }, function (data) {
                if (!data.length) {
                    $container.find("div.loadmask").remove();
                    $container.remove();
                    return;
                }

                var $html = $(data);
                // append the data, remove the loading element, then trigger the insert.
                $container.append($html);
                $container.find("div.loadmask").remove();
                Cobalt.triggerHtmlInsert($container);
                $container.parent().center();

                $container.find("a.j-login-modal").on("click", function (e) {
                    Cobalt.Auth.replaceWithLoginModel($container);
                });

                // focus on username field
                $('#field-username').focus();
            });
        },
        loadLoginContainer: function ($container, html) {
            $container.html(html);
            $container.find("a.j-register-modal").on("click", function (e) {
                Cobalt.Auth.replaceWithRegisterModel($container);
            });
            Cobalt.triggerHtmlInsert($container);

            return $container;
        },
        loadRegisterContainer: function ($container, html) {
            $container.html(html);
            $container.find("a.j-login-modal").on("click", function (e) {
                Cobalt.Auth.replaceWithLoginModel($container);
            });
            Cobalt.triggerHtmlInsert($container);
            return $container;
        },
        replaceWithRegisterModel: function ($container) {
            var loaded = false;
            setTimeout(function () {
                if (!loaded)
                    $container.append("<div class=\"loadmask\"></div>");
            }, Cobalt.Auth.modalLoadTime);

            $.ajax({
                url: "https://" + window.location.hostname + "/register-modal",
                xhrFields: {
                    withCredentials: true
                },
                data: { "returnUrl": window.location.pathname },
                success: function (html) {
                    $container.removeClass();
                    $container.addClass("p-register p-register-b group j-register-modal ui-dialog-content ui-widget-content");
                    $container.parent().removeClass("loginModal").addClass("register-modal");
                    Cobalt.Auth.loadRegisterContainer($container, html);
                    // focus on username field
                    $('#field-username').focus();
                    loaded = true;
                }
            });

            if (loaded) {
                $container.find("div.loadmask").remove();
            }
        },
        replaceWithLoginModel: function ($container) {
            var loaded = false;
            setTimeout(function () {
                if (!loaded)
                    $container.append("<div class=\"loadmask\"></div>");
            }, Cobalt.Auth.modalLoadTime);

            $.ajax({
                url: "https://" + window.location.hostname + "/login-modal",
                xhrFields: {
                    withCredentials: true
                },
                data: { "returnUrl": window.location.pathname },
                success: function (html) {
                    $container.removeClass();
                    $container.addClass("p-login p-login-b group j-login-modal ui-dialog-content ui-widget-content");
                    $container.parent().removeClass("register-modal").addClass("loginModal");
                    Cobalt.Auth.loadLoginContainer($container, html);
                    // focus on username field
                    $('#field-username').focus();
                    loaded = true;
                }
            });

            if (loaded) {
                $container.find("div.loadmask").remove();
            }
        }
    };

})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Auth.js